<script setup>
const { generateBreadcrumbs } = useMetaUtils()
const { formatDate } = useFormatters()
const { getPosts } = useApiPost()

const { data: posts } = await useAsyncData('pages-blog-posts', () =>
  getPosts(999),
)

useSeoMeta({
  title: 'Blog',
})
</script>

<template>
  <section>
    <SectionsHero
      :breadcrumbs="generateBreadcrumbs({ slug: 'blog', title: 'Blog' })"
      :content="{ title: 'Blog', style: 'Primary' }"
      first-is-hero
    />
    <BaseContainer class="my-12 md:my-16">
      <div
        v-if="posts?.length"
        class="grid grid-cols-1 gap-x-3 gap-y-5 sm:grid-cols-2 sm:gap-x-10 sm:gap-y-10 lg:grid-cols-3"
      >
        <BaseCard
          v-for="(post, index) of posts"
          :key="index"
          :truncate="false"
          :content="{
            visual: post?.image || null,
            ...post,
            subTitle: formatDate(post?.publishedAt),
            content: post?.excerpt || '',
            link: {
              title: 'Lees artikel',
              url: '/blog/' + post?.slug,
            },
          }"
          :lazy="index !== 0"
        />
      </div>
    </BaseContainer>
  </section>
</template>
